import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight, PlusCircle, FileText, Users, Upload } from 'lucide-react';

interface NextBestActionsCardProps {
  companyId: string;
}

const actions = [
  {
    label: 'Complete founder cap table',
    description: 'Add all founders and their shares',
    icon: Users,
    path: '/shareholders',
  },
  {
    label: 'Add your first funding round',
    description: 'Model pre-money, post-money, and dilution',
    icon: PlusCircle,
    path: '/funding-rounds',
  },
  {
    label: 'Generate valuation brief',
    description: 'Get an AI-powered valuation range',
    icon: FileText,
    path: '/valuation',
  },
  {
    label: 'Invite advisor or observer',
    description: 'Give stakeholders read-only access',
    icon: Users,
    path: '/settings?tab=team-access',
  },
  {
    label: 'Upload pitch deck',
    description: 'Store key documents in your data room',
    icon: Upload,
    path: '/data-room',
  },
];

export function NextBestActionsCard({ companyId }: NextBestActionsCardProps) {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-medium">Next best actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-1 pt-0">
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={() => navigate(action.path)}
            className="w-full flex items-center gap-3 p-3 rounded-lg text-left hover:bg-muted/50 transition-colors group"
          >
            <div className="h-8 w-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
              <action.icon className="h-4 w-4 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">{action.label}</p>
              <p className="text-xs text-muted-foreground">{action.description}</p>
            </div>
            <ArrowRight className="h-4 w-4 text-muted-foreground/40 group-hover:text-primary transition-colors flex-shrink-0" />
          </button>
        ))}
      </CardContent>
    </Card>
  );
}
